export const initPageHeader = (headerEl) => {
    if (!headerEl) {
        return;
    }

    const menuToggle = headerEl?.querySelector('[data-toggle="mobile-nav"]');
    const navAnchorLinks = headerEl?.querySelectorAll('#main-nav a[href*="#"]');

    menuToggle?.addEventListener("click", (e) => {
        e.preventDefault();

        const mainNav = document.getElementById("main-nav");

        menuToggle?.classList?.toggle("is-open");
        mainNav?.classList?.toggle("is-open");
    });

    for (const anchor of navAnchorLinks) {
        anchor.addEventListener("click", () => {
            if (anchor.getAttribute("href").indexOf("#") !== 0) {
                return;
            }

            const mainNav = document.getElementById("main-nav");

            menuToggle?.classList?.remove("is-open");
            mainNav?.classList?.remove("is-open");
        });
    }

    const subnavToggles = headerEl.querySelectorAll(".mobile-subtoggle");
    for (const toggle of subnavToggles) {
        toggle.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isOpen = toggle.getAttribute("aria-expanded") === "true";
            closeAllSubnavs();

            if (!isOpen) {
                toggle.setAttribute("aria-expanded", true);
                // document.addEventListener("click", closeAllSubnavs);
            }
        });
    }

    const megaMenuToggles = headerEl?.querySelectorAll(".megamenu-subtoggle");
    for (const toggle of megaMenuToggles) {
        toggle.addEventListener("click", () => {
            const isOpen = toggle.classList.contains("is-open");
            // closeAllMegaMenuSubnavs();
            const menuId = toggle.getAttribute("aria-controls");
            const menu = document.getElementById(menuId);

            if (!isOpen) {
                toggle.setAttribute("aria-expanded", true);
                toggle.classList.add("is-open");
                menu?.classList.add("is-open");
                menu?.classList.add("is-acitve");
            } else {
                toggle.setAttribute("aria-expanded", false);
                toggle.classList.remove("is-open");
                menu?.classList.remove("is-open");
                menu?.classList.remove("is-acitve");
            }
        });
    }

    function closeAllSubnavs() {
        //document.removeEventListener("click", closeAllSubnavs);
        for (const toggle of subnavToggles) {
            toggle.setAttribute("aria-expanded", false);
        }
    }

    // function closeAllMegaMenuSubnavs() {
    //     const submenus = headerEl?.querySelectorAll(
    //         '.megamenu [role="tabpanel"]',
    //     );

    //     for (const menu of submenus) {
    //         menu.classList.remove("is-open");
    //         menu.classList.remove("is-active");
    //     }

    //     for (const toggle of megaMenuToggles) {
    //         toggle.classList.remove("is-open");
    //         toggle.setAttribute("aria-expanded", false);
    //     }
    // }
};
